export const SUPPORTED_LANGUAGES = ['en', 'he', 'ar'] as const;
export const DEFAULT_LANGUAGE = 'he';
